import { APIServiceService } from './apiservice.service';
import { Customer } from '../models/customer.model';
import { APIResponse } from '../models/api-response.model';
import { Rider } from '../models/rider.model';


export class RiderEndpoint {

  constructor(private apiService: APIServiceService) {}
  endpoint = 'riders/';


  async create(rider: Rider): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint, token, rider).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  
  async search(term: string, customerId: number, page: number = 0, size: number = 10): Promise<{ success: boolean, data: { total: number, results: Customer[] } }> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + 'search', token, { term, customerId, page, size }).toPromise();
      if (response.success) {
        response.data.results = response.data.results.map(c => new Customer().deserialize(c));
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getByID(id: number): Promise<APIResponse> {
      try {
        const token = await this.apiService.getCurrentUserToken();
        if (!token) {
          throw new Error('no_auth_token');
        }
        const response = await this.apiService.doGET(this.endpoint + id, token , {}).toPromise();
        return response;
      } catch (error) {
        throw error;
      }
    }
  
  
}
